import { render } from "./ModalCobro.vue?vue&type=template&id=13dcfd38&scoped=true"
import script from "./ModalCobro.vue?vue&type=script&lang=js"
export * from "./ModalCobro.vue?vue&type=script&lang=js"

import "./ModalCobro.vue?vue&type=style&index=0&id=13dcfd38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dcfd38"]])

export default __exports__